import React from "react"
import ReactDOM from "react-dom"
import FollowFlight from "./follow-flight-component"

export default class FollowFlightModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<FollowFlight {...self.elem.dataset} />, self.elem)
  }
}
